<template>
    <svg width="52" height="44" viewBox="0 0 52 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="UserPlus">
            <g id="Vector">
                <path
                    d="M36.5321 43.576H4.58713C1.81864 43.576 -0.153017 40.879 0.694898 38.2433L4.05591 27.7414C5.13879 24.3804 8.8267 22.6233 12.1162 23.9003C14.3024 24.7482 17.1117 25.4122 20.5443 25.4122C23.9768 25.4122 26.7964 24.7482 28.9723 23.9003C32.272 22.6233 35.96 24.3702 37.0326 27.7414L40.3936 38.2433C41.2722 40.879 39.3005 43.576 36.5321 43.576Z"
                    fill="url(#paint0_linear_5391_15771)" />
                <path
                    d="M36.5321 43.576H4.58713C1.81864 43.576 -0.153017 40.879 0.694898 38.2433L4.05591 27.7414C5.13879 24.3804 8.8267 22.6233 12.1162 23.9003C14.3024 24.7482 17.1117 25.4122 20.5443 25.4122C23.9768 25.4122 26.7964 24.7482 28.9723 23.9003C32.272 22.6233 35.96 24.3702 37.0326 27.7414L40.3936 38.2433C41.2722 40.879 39.3005 43.576 36.5321 43.576Z"
                    fill="url(#paint1_linear_5391_15771)" />
            </g>
            <g id="Vector_2">
                <path
                    d="M20.5647 21.4892C26.3816 21.4892 31.0972 16.7736 31.0972 10.9567C31.0972 5.1397 26.3816 0.424133 20.5647 0.424133C14.7477 0.424133 10.0322 5.1397 10.0322 10.9567C10.0322 16.7736 14.7477 21.4892 20.5647 21.4892Z"
                    fill="url(#paint2_linear_5391_15771)" />
                <path
                    d="M20.5647 21.4892C26.3816 21.4892 31.0972 16.7736 31.0972 10.9567C31.0972 5.1397 26.3816 0.424133 20.5647 0.424133C14.7477 0.424133 10.0322 5.1397 10.0322 10.9567C10.0322 16.7736 14.7477 21.4892 20.5647 21.4892Z"
                    fill="url(#paint3_linear_5391_15771)" />
            </g>
            <path id="Vector_3"
                d="M48.4948 12.8262H45.144V9.47545C45.144 7.93286 43.8977 6.68652 42.3551 6.68652C40.8125 6.68652 39.5662 7.93286 39.5662 9.47545V12.8262H36.2154C34.6728 12.8262 33.4265 14.0726 33.4265 15.6152C33.4265 17.1578 34.6728 18.4041 36.2154 18.4041H39.5662V21.7549C39.5662 23.2975 40.8125 24.5438 42.3551 24.5438C43.8977 24.5438 45.144 23.2975 45.144 21.7549V18.4041H48.4948C50.0374 18.4041 51.2837 17.1578 51.2837 15.6152C51.2939 14.0726 50.0374 12.8262 48.4948 12.8262Z"
                fill="url(#paint4_linear_5391_15771)" />
        </g>
        <defs>
            <linearGradient id="paint0_linear_5391_15771" x1="0.496155" y1="38.5524" x2="0.496155" y2="38.5524"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#F99AB7" />
                <stop offset="1" stop-color="#F74590" />
            </linearGradient>
            <linearGradient id="paint1_linear_5391_15771" x1="20.5506" y1="23.4816" x2="20.5506" y2="43.576"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#FA96B3" />
                <stop offset="1" stop-color="#F45484" />
            </linearGradient>
            <linearGradient id="paint2_linear_5391_15771" x1="10.0322" y1="16.2229" x2="10.0322" y2="16.2229"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#F99AB7" />
                <stop offset="1" stop-color="#F74590" />
            </linearGradient>
            <linearGradient id="paint3_linear_5391_15771" x1="20.5647" y1="0.424133" x2="20.5647" y2="21.4892"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#FA96B3" />
                <stop offset="1" stop-color="#F45484" />
            </linearGradient>
            <linearGradient id="paint4_linear_5391_15771" x1="33.4265" y1="20.0795" x2="51.2838" y2="20.0795"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#F45484" />
                <stop offset="0.0001" stop-color="#1DC39F" />
                <stop offset="1" stop-color="#11B08E" />
            </linearGradient>
        </defs>
    </svg>
</template>



<script>
export default {
  name: "UserPlus",
};
</script>